import { useReveal } from "../hooks/useReveal";
import { MEDIA } from "../lib/media";

// Subtle tilt angles for an organic scatter
const TILTS = ["-2.4deg", "1.8deg", "-1.2deg", "2.6deg", "-1.5deg", "1.0deg"];

export default function Gallery() {
  const { ref, visible } = useReveal();

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      ref={ref}
      className={`relative bg-[#FAFBFC] py-28 md:py-36 px-6 md:px-12 lg:px-20 reveal ${
        visible ? "in-view" : ""
      }`}
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-24">
          <div>
            <div className="overline mb-5">photos · gallery</div>
            <h2 className="font-serif-display text-5xl md:text-7xl text-[#0A0A0A] leading-[0.95] tracking-tight">
              <span className="italic">Photographs.</span>
            </h2>
          </div>
          <p className="text-base md:text-lg text-[#595959] leading-relaxed max-w-md">
            A growing archive — film, frames, and moments from the season.
          </p>
        </div>

        {/* Polaroid scatter grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16 md:gap-y-20">
          {MEDIA.gallery.map((g, i) => {
            const tilt = TILTS[i % TILTS.length];
            // alternate slight vertical offset for visual interest
            const offset = i % 3 === 1 ? "md:translate-y-10" : (i % 3 === 2 ? "md:-translate-y-4" : "");
            return (
              <figure
                key={i}
                data-testid={`gallery-image-${i}`}
                className={`polaroid relative ${offset}`}
                style={{ transform: `rotate(${tilt})` }}
              >
                <div className="relative aspect-[4/5] overflow-hidden bg-[#F2F4F6]">
                  <img
                    src={g.url}
                    alt={g.caption}
                    className="w-full h-full object-cover"
                    style={{ filter: "saturate(0.98) contrast(1.02)" }}
                  />
                </div>
                <figcaption className="mt-3 px-1 flex items-center justify-between font-mono-meta text-[10px] tracking-[0.26em] uppercase text-[#8C8C8C]">
                  <span>{String(i + 1).padStart(2, "0")}</span>
                  <span className="text-[#595959] truncate ml-3 italic font-serif-display normal-case tracking-normal text-base">
                    {g.caption}
                  </span>
                </figcaption>
              </figure>
            );
          })}
        </div>

        <div className="mt-24 flex items-center justify-between">
          <div className="font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#8C8C8C]">
            {String(MEDIA.gallery.length).padStart(2, "0")} frames
          </div>
          <button
            data-testid="view-full-archive"
            className="font-mono-meta text-[10px] tracking-[0.3em] uppercase text-[#0A0A0A] link-underline hover:text-[#6B8FAE] transition-colors"
          >
            view the full archive →
          </button>
        </div>
      </div>
    </section>
  );
}
